import { h } from 'preact';
import Store from 'store/store';
import * as BaseComp from 'base/bolt/boltApp.js';
import 'store/customTracking';
// import s from 'base/bolt/boltApp.sss';

export default class BoltApp extends BaseComp.default {
	constructor(props) {
		super(props);
		this.state = { ...this.state, videoProgressTracked: 0 };
		this.trackVideoPlayPercentage = this.trackVideoPlayPercentage.bind(this);
	}

	componentDidUpdate(...args) {
		super.componentDidUpdate(...args);
		if (!this.state.playTrackPercentageListener && this.$bgVideo) {
			this.setState({ playTrackPercentageListener: true });
			this.$bgVideo.addEventListener('timeupdate', this.trackVideoPlayPercentage);
		}
	}

	trackVideoPlayPercentage(e) {
		const progress = (e.target.currentTime / e.target.duration) * 100;

		const steppedProgress = Math.floor(progress / 25) * 25;

		if (this.state.videoProgressTracked === 0) {
			this.setState({ videoProgressTracked: 10 });
			Store.emit('TRACK_HOME_BG_VIDEO_PLAY_PERCENTAGE', { percentage: 0 });
		} else if (progress >= this.state.videoProgressTracked + 25 && steppedProgress <= 100) {
			this.setState({ videoProgressTracked: steppedProgress });
			Store.emit('TRACK_HOME_BG_VIDEO_PLAY_PERCENTAGE', { percentage: steppedProgress });
		} else if (progress <= 25 && this.state.videoProgressTracked === 75) {
			this.setState({ videoProgressTracked: 100 });
			Store.emit('TRACK_HOME_BG_VIDEO_PLAY_PERCENTAGE', { percentage: 100 });
		}
	}

	componentWillUnmount() {
		super.componentWillUnmount();
		this?.$bgVideo.removeEventListener('timeupdate', this.trackVideoPlayPercentage);
	}
}
